<template>
  <div>
    <!-- signUp teacher Section -->
    <section class="signUp">
      <v-container style="z-index: 888 !important">
        <v-row justify="center">
          <v-col cols="3" sm="3" class="d-none d-md-flex">
            <ul class="list-unstyled accordion-nav">
              <li
                @click="openTab(0)"
                :class="{ active: panel[0] == 0 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("generalInfo") }}
              </li>
              <li
                @click="openTab(1)"
                :class="{ active: panel[0] == 1 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("jobInfo") }}
              </li>
              <li
                @click="openTab(2)"
                :class="{ active: panel[0] == 2 && panel.length == 1 }"
              >
                {{ $t("teachingAndcurriculums") }}
              </li>
              <!-- <li
                @click="openTab(3)"
                :class="{ active: panel[0] == 3 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("teacherFees") }}
              </li> -->
              <li
                @click="openTab(4)"
                :class="{ active: panel[0] == 4 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("bankInfo") }}
              </li>
              <li
                @click="openTab(5)"
                :class="{ active: panel[0] == 5 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("attachments") }}
              </li>
              <li
                @click="openTab(6)"
                :class="{ active: panel[0] == 6 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("socialMediaAccounts") }}
              </li>

              <li
                @click="openTab(7)"
                :class="{ active: panel[0] == 7 && panel.length == 1 }"
                class="capitalize"
              >
                {{ $t("Acknowledgments") }}
              </li>
            </ul>
          </v-col>
          <v-col cols="9" sm="9">
            <v-row>
              <v-col class="text-center">
                <h2 class="section-title signup-title capitalize">
                  {{ $t("createTeacherAccount") }}
                </h2>
              </v-col>
            </v-row>
            <validation-observer ref="observer">
              <v-form ref="form" v-model="valid">
                <v-expansion-panels accordion v-model="panel" multiple>
                  <!-- first tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                    >
                      {{ $t("generalInfo") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row style="padding-top: 10px">
                        <v-col cols="12" sm="12" md="6">
                          <label for="name" class="capitalize"
                            >{{ $t("name") }}*</label
                          >
                          <v-text-field
                            solo
                            :rules="[validationRules.required]"
                            v-model.trim="teacherRegistration.first_name"
                            @focus="onFocus"
                          ></v-text-field>
                          <div
                            class="validationError"
                            v-if="
                              validationErrors && validationErrors.first_name
                            "
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(
                                error, index
                              ) in validationErrors.first_name"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="family-name" class="capitalize"
                            >{{ $t("familyName") }}*</label
                          >
                          <v-text-field
                            solo
                            :rules="[validationRules.required]"
                            v-model.trim="teacherRegistration.family_name"
                            @focus="onFocus"
                          ></v-text-field>

                          <div
                            class="validationError"
                            v-if="
                              validationErrors && validationErrors.family_name
                            "
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(
                                error, index
                              ) in validationErrors.family_name"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="email" class="capitalize"
                            >{{ $t("email") }}*</label
                          >
                          <v-text-field
                            solo
                            :rules="[
                              validationRules.required,
                              validationRules.email,
                            ]"
                            v-model.trim="teacherRegistration.email"
                            @focus="onFocus"
                            :disabled="isLoggedIn"
                          ></v-text-field>
                          <div
                            class="validationError"
                            v-if="validationErrors && validationErrors.email"
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(error, index) in validationErrors.email"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>

                        <v-col cols="12" md="2" sm="4" class="countryCode">
                          <label class="capitalize" for="phone"
                            >{{ $t("mobil") }}*</label
                          >
                          <div
                            class="code applicant-country-code"
                            id="country-code"
                            style="direction: ltr !important"
                          >
                            <v-autocomplete
                              :items="dataObject.Codes"
                              class="form-control"
                              outlined
                              solo
                              @change="hideLabel = true"
                              item-text="title"
                              item-value="value"
                              value="187"
                              v-model="teacherRegistration.country_code_id"
                              :rules="[validationRules.required]"
                              ><template slot="selection" slot-scope="data">
                                <v-flex xs2>
                                  <!-- <v-avatar size="25px"> -->
                                  <img :src="data.item.icon" class="flag-img" />
                                  <!-- </v-avatar> -->
                                </v-flex>
                                <v-flex class="ml-4">
                                  {{ data.item.title }}
                                </v-flex>
                              </template>
                              <template slot="item" slot-scope="data">
                                <!-- <v-list-item-avatar
                                  style="width: 20px; min-width: 20px; height: 20px;"
                                > -->
                                <img :src="data.item.icon" class="flag-img" />
                                <!-- </v-list-item-avatar> -->
                                <v-list-item-content>
                                  <v-list-item-title
                                    v-html="data.item.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-col>
                        <v-col cols="12" md="4" sm="8">
                          <label
                            for
                            style="visibility: hidden"
                            class="d-none d-sm-block"
                            >fsadf</label
                          >
                          <v-text-field
                            solo
                            :rules="[
                              validationRules.required,
                              validationRules.numeric,
                            ]"
                            v-model.trim="teacherRegistration.mobile"
                            @focus="onFocus"
                          ></v-text-field>

                          <div
                            class="validationError"
                            v-if="validationErrors && validationErrors.mobile"
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(error, index) in validationErrors.mobile"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" v-if="!isLoggedIn">
                          <label for="pass" class="capitalize"
                            >{{ $t("password") }}*</label
                          >
                          <v-text-field
                            solo
                            :rules="[
                              validationRules.required,
                              validationRules.password,
                            ]"
                            v-model.trim="teacherRegistration.password"
                            @focus="onFocus"
                            :append-icon="
                              togglePassword ? 'mdi-eye-off' : 'mdi-eye'
                            "
                            @click:append="
                              () => (togglePassword = !togglePassword)
                            "
                            :type="togglePassword ? 'password' : 'text'"
                            class="password"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6">
                          <label for="nickname" class="capitalize"
                            >{{ $t("title") }} *</label
                          >
                          <v-radio-group
                            v-model="teacherRegistration.title"
                            :rules="[validationRules.required]"
                            row
                          >
                            <v-radio
                              color="#ffffff"
                              :label="$t('Mr.')"
                              value="mr"
                            ></v-radio>
                            <v-radio :label="$t('Ms.')" value="ms"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="birthdate"
                            >{{ $t("dateOfBirth") }} *</label
                          >
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="teacherRegistration.birthdate"
                                label
                                append-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                :rules="[validationRules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="teacherRegistration.birthdate"
                              @input="menu2 = false"
                              :max="nowDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="phone" class="capitalize"
                            >{{ $t("country/nationality") }}*</label
                          >
                          <v-select
                            solo
                            :items="dataObject.nationalities"
                            item-text="name"
                            item-value="id"
                            chips
                            :rules="[validationRules.required]"
                            v-model="teacherRegistration.nationality_id"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <div class="profile-image text-center">
                            <v-btn
                              class="edit-btn"
                              @click="profileSelectFile"
                              icon
                            >
                              <v-icon color="#13a8b1" small>edit</v-icon>
                            </v-btn>
                            <v-img
                              :src="defaultAvaterMale"
                              v-if="!teacherRegistration.avatar"
                              max-width="150"
                              class="rounded"
                            >
                            </v-img>
                            <v-img
                              :src="teacherRegistration.avatar"
                              v-if="teacherRegistration.avatar"
                              max-width="150"
                            >
                            </v-img>
                            <v-file-input
                              style="display: none"
                              id="avatar"
                              @change="profileOnAddFile"
                              accept="image/*"
                            ></v-file-input>
                            <v-btn
                              v-if="teacherRegistration.avatar"
                              class="close-btn"
                              icon
                              @click="deleteProfileImage"
                            >
                              <!-- v-if="teacherRegistration.avatar" -->
                              <v-icon color="#13a8b1" small>close</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- second tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                    >
                      {{ $t("jobInfo") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <label for="name" class="capitalize">{{
                            $t("affilation")
                          }}</label>
                          <v-text-field
                            v-model.trim="teacherRegistration.affilation"
                            solo
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <label for="name" class="capitalize"
                            >{{ $t("teaching_experience") }} *</label
                          >
                          <v-textarea
                            solo
                            :rules="[validationRules.required]"
                            v-model.trim="
                              teacherRegistration.teaching_experience
                            "
                            @focus="onFocus"
                          ></v-textarea>
                          <div
                            class="validationError"
                            v-if="
                              validationErrors &&
                              validationErrors.teaching_experience
                            "
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(
                                error, index
                              ) in validationErrors.teaching_experience"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- third tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                    >
                      {{ $t("teachingAndcurriculums") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <label for="name" class="capitalize"
                            >{{ $t("curriculum") }} *</label
                          >
                          <v-select
                            solo
                            :rules="[validationRules.required]"
                            v-model="teacherRegistration.curriculum_id"
                            :items="dataObject.curriculums"
                            chips
                            @change="
                              getGradesUnderCurriculum(
                                teacherRegistration.curriculum_id
                              )
                            "
                            @focus="onFocus"
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label class="capitalize" for="name"
                            >{{ $t("grades") }} *</label
                          >
                          <v-select
                            solo
                            v-model="teacherRegistration.grades"
                            :rules="[
                              checkMultiSelect(teacherRegistration.grades),
                            ]"
                            :items="grades"
                            item-text="name"
                            item-value="id"
                            chips
                            multiple
                            @change="
                              getSubjectsUnderGrade(teacherRegistration.grades)
                            "
                            @focus="onFocus"
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip v-if="index < 2">
                                <span>{{ item.name }}</span>
                              </v-chip>
                              <span
                                v-if="index === 2"
                                class="grey--text caption"
                              >
                                (+{{ teacherRegistration.grades.length - 2 }}
                                {{ $t("others") }})
                              </span>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                      <!-- start v-expansion -->
                      <v-expansion-panels
                        v-model="openPanels"
                        class="inner-expansion"
                        multiple
                      >
                        <v-expansion-panel
                          v-for="(gradeId, index) in Object.keys(panels)"
                          :key="index"
                        >
                          <v-expansion-panel-header
                            class="capitalize"
                            color="#FFC382"
                          >
                            {{ gradesWithNames[gradeId] }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content
                            style="background-color: #ffffff !important"
                          >
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <label for="name" class="capitalize"
                                  >{{ $t("subjects") }} *</label
                                >
                                <v-select
                                  v-model="
                                    teacherRegistration.subjects[gradeId]
                                  "
                                  solo
                                  :items="panels[gradeId]"
                                  item-text="name"
                                  item-value="id"
                                  :rules="[
                                    checkMultiSelect(
                                      teacherRegistration.subjects[gradeId]
                                    ),
                                  ]"
                                  chips
                                  multiple
                                  @focus="onFocus"
                                  @change="addEditSubjectFees(gradeId)"
                                >
                                  <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index < 2">
                                      <span>{{ item.name }}</span>
                                    </v-chip>
                                    <span
                                      v-if="index === 2"
                                      class="grey--text caption"
                                    >
                                      (+{{
                                        teacherRegistration.subjects[gradeId]
                                          .length - 2
                                      }}
                                      {{ $t("others") }})
                                    </span>
                                  </template>
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row
                              v-for="(subjectFee, i) in teacherRegistration
                                .subjectsFees[gradeId]"
                              :key="i"
                            >
                              <div
                                v-if="subjectFee && subjectFee != undefined"
                                class="row"
                              >
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  style="text-align: center; font-weight: bold"
                                >
                                  <p class="mt-4 capitalize main-color">
                                    {{ subjectFee.subject }}
                                  </p>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <label for="name" class="capitalize"
                                    >{{ $t("trainingHourPrice") }} *</label
                                  >
                                  <v-text-field
                                    solo
                                    :rules="[
                                      validationRules.required,
                                      validationRules.minOne,
                                    ]"
                                    v-model.trim="subjectFee.hourFees"
                                    type="number"
                                    min="1"
                                  >
                                    <template v-slot:append>
                                      <span>{{ $t("currency") }}</span>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <label for="name" class="capitalize"
                                    >{{ $t("languages") }} *</label
                                  >
                                  <!-- :rules="[
                                    checkMultiSelect(
                                      teacherRegistration.subjectsFees[id][
                                        index
                                      ].languages
                                    ),
                                  ]" -->
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="item.languages"
                                    rules="required"
                                  >
                                    <v-select
                                      solo
                                      v-model="subjectFee.languages"
                                      :items="dataObject.languages"
                                      item-text="name"
                                      item-value="id"
                                      chips
                                      multiple
                                      :error-messages="errors"
                                    >
                                      <template
                                        v-slot:selection="{ item, index }"
                                      >
                                        <v-chip v-if="index < 2">
                                          <span>{{ item.name }}</span>
                                        </v-chip>
                                        <span
                                          v-if="index === 2"
                                          class="grey--text caption"
                                        >
                                          (+{{
                                            subjectFee.languages.length - 2
                                          }}
                                          {{ $t("others") }})
                                        </span>
                                      </template>
                                    </v-select>
                                  </validation-provider>
                                </v-col>
                              </div>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <!-- end v-expansion -->
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- fifth tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                      >{{ $t("bankInfo") }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <label for="name">{{ $t("IBAN") }} *</label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.IBAN"
                            :rules="[validationRules.required]"
                          ></v-text-field>
                          <div
                            class="validationError"
                            v-if="validationErrors && validationErrors.IBAN"
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(error, index) in validationErrors.IBAN"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label for="name" class="capitalize">{{
                            $t("accountBankInfo")
                          }}</label>
                          <v-file-input
                            multiple
                            label="File input"
                            @change="onAddFile"
                            accept="image/*"
                          ></v-file-input>
                          <!-- :rules="[validationRules.imageValidation]" -->
                          <p class="error--text image-error">
                            {{ bankAttachImgError }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- 6 tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                      >{{ $t("attachments") }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <label for="name">{{ $t("identityNumber") }} *</label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.national_id"
                            :rules="[validationRules.required]"
                          ></v-text-field>

                          <div
                            class="validationError"
                            v-if="
                              validationErrors && validationErrors.national_id
                            "
                          >
                            <p
                              class="error--text backend-error"
                              v-for="(
                                error, index
                              ) in validationErrors.national_id"
                              :key="index"
                            >
                              <span>{{ error }}</span>
                            </p>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <label for="name"
                            >{{ $t("copyOfIdentityNumber") }} *</label
                          >
                          <v-file-input
                            label="File input"
                            @change="onAddFileForAttachments"
                            :rules="[validationRules.required]"
                            multiple
                            accept="image/*"
                          ></v-file-input>
                          <!-- validationRules.imageValidation -->
                          <p class="error--text image-error">
                            {{ attachImgError }}
                          </p>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 7 tab -->
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      color="#187e89"
                      class="capitalize"
                      >{{ $t("socialChannels") }}</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <label for="linkedIn" class="capitalize"
                            >{{ $t("linkedIn") }}
                          </label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.linkedIn"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="facebook" class="capitalize"
                            >{{ $t("facebook") }}
                          </label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.facebook"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="email" class="capitalize"
                            >{{ $t("Twetter") }}
                          </label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.twitter"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="pass" class="capitalize"
                            >{{ $t("Snapcaht") }}
                          </label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.snapchat"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                          <label for="phone" class="capitalize"
                            >{{ $t("instegram") }}
                          </label>
                          <v-text-field
                            solo
                            v-model.trim="teacherRegistration.instagram"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 8 tab -->
                  <v-expansion-panel class="endorsments">
                    <v-expansion-panel-header class="capitalize" color="#187e89"
                      >{{ $t("Endorsements") }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div
                        class="endors"
                        v-for="(
                          item, index
                        ) in teacherRegistration.endorsements"
                        :key="index"
                      >
                        <v-checkbox
                          class="mx-2 white-checkbox"
                          style="color: #ffffff !important"
                          :label="item.text + ' *'"
                          v-model="item.value"
                          :rules="[validationRules.required]"
                        ></v-checkbox>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form>
              <v-btn
                class="primary-btn no-caps"
                @click.prevent="submit"
                :loading="loading"
                :disabled="loading"
                >{{ $t("Register-Teacher") }}</v-btn
              >
            </validation-observer>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";
import { required } from "vee-validate/dist/rules";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";

import AUTH from "../../auth";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  name: "TeacherSignUp",
  mixins: [validationMixin],
  data() {
    return {
      hideLabel: false,
      togglePassword: true,
      openPanels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      lastGradeIds: [],
      lastSubjectIds: {},
      loading: false,
      nowDate: new Date(Date.now() - 864e5).toISOString().slice(0, 10),
      panel: [0],
      valid: false,
      teacherRegistration: {
        avatar: "",
        first_name: "",
        family_name: "",
        email: "",
        country_code_id: "",
        mobile: "",
        title: "",
        password: "",
        birthdate: "",
        nationality_id: "",
        affilation: "",
        teaching_experience: "",
        curriculum_id: "",
        grades: [],
        subjects: [],
        subjectsFees: [],
        IBAN: "",
        bank_info: "",
        national_id: "",
        id_photo: "",
        linkedIn: "",
        facebook: "",
        twitter: "",
        instagram: "",
        snapchat: "",
        endorsements: [],
        from_market: false,
      },
      dataObject: {
        nationalities: ["egyp", "saudi"],
        curriculums: ["national", "international", "american"],
        languages: ["arabic", "english", "french"],
        Codes: [],
      },
      grades: [],
      gradesWithNames: [],
      gradesWithSubjects: [],
      panels: {},
      subjects: [],
      validationErrors: {},
      bankAttachImgError: "",
      attachImgError: "",

      /* datepicker */
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      menu2: false,
      teacherOrStudent: AUTH.teacherOrStudent(),
      isLoggedIn: AUTH.isLoggedIn(),
    };
  },
  // watch: {
  //   "teacherRegistration.subjects": {
  //     handler() {
  //       this.addEditSubjectFees();
  //     },
  //   },
  // },
  methods: {
    profileSelectFile() {
      document.getElementById("avatar").click();
    },
    profileOnAddFile(File) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.teacherRegistration.avatar = e.target.result;
      };
      reader.readAsDataURL(File);
    },
    deleteProfileImage() {
      this.teacherRegistration.avatar = "";
    },
    onFocus() {
      this.validationErrors = {};
    },
    submitOnClick() {
      document.addEventListener("keydown", (event) => {
        if (event.keyCode === 13) {
          this.submit();
        }
        // do something
      });
    },
    getDataForTeacherRegistration() {
      this.$http
        .get(this.getApiUrl + "/getDataForTeacherRegistration?type=teacher")
        .then((response) => {
          // console.log(response.data.data);
          this.dataObject.nationalities = response.data.data.nationalities;
          this.dataObject.curriculums = response.data.data.curricula;
          this.dataObject.languages = response.data.data.languages;
          // this.dataObject.Codes = response.data.data.country_codes;
          this.teacherRegistration.endorsements =
            response.data.data.endorsements;
        });
    },

    getGradesUnderCurriculum(curriculumId) {
      if (this.grades.length > 0) {
        this.grades = [];
      }
      if (this.subjects.length > 0) {
        this.subjects = [];
      }

      if (this.teacherRegistration.grades.length > 0) {
        this.teacherRegistration.grades = [];
      }
      // if (this.openPanels.length > 0) {
      //   this.openPanels = [];
      // }
      this.$http
        .get(
          this.getApiUrl +
            "/getGradesUnderCurriculum/" +
            curriculumId +
            "?withSubs"
        )
        .then((response) => {
          this.grades = response.data.data.grades;
          this.grades.forEach((item, index) => {
            // this.openPanels.push(index);
            this.lastSubjectIds[item.id] = [];
          });
          this.gradesWithNames = response.data.data.gradesWithNames;
          this.gradesWithSubjects = response.data.data.gradesWithSubjects;
        });
    },
    getSubjectsUnderGrade() {
      // this.panels = {};
      const difference = this.array_diff(
        this.lastGradeIds,
        this.teacherRegistration.grades
      );
      let mode = "+";
      if (this.lastGradeIds.length > this.teacherRegistration.grades.length)
        mode = "-";
      this.openPanels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      if (mode == "+") {
        difference.forEach((gradeId) => {
          this.panels[gradeId] = this.gradesWithSubjects[gradeId];
          this.teacherRegistration.subjects[gradeId] = [];
          this.teacherRegistration.subjectsFees[gradeId] = [];
        });
      } else {
        difference.forEach((gradeId) => {
          delete this.panels[gradeId];
          this.teacherRegistration.subjects[gradeId] = [];
          this.teacherRegistration.subjectsFees[gradeId] = [];
          this.lastSubjectIds[gradeId] = this.teacherRegistration.subjects[
            gradeId
          ];
        });
      }
      this.lastGradeIds = this.teacherRegistration.grades;
    },
    onAddFile(File) {
      if (File.length > 0) {
        const selectedImage = File[0];

        if (
          selectedImage &&
          selectedImage.type &&
          !selectedImage.type.startsWith("image")
        ) {
          this.bankAttachImgError = "مسموح بالصور فقط";
        } else {
          this.bankAttachImgError = "";
        }

        this.createBase64Image(selectedImage);
      }
    },
    createBase64Image(fileObject) {
      const reader = new FileReader();
      // const _this = this;
      reader.onload = (e) => {
        this.teacherRegistration.bank_info = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },

    onAddFileForAttachments(File) {
      if (File.length > 0) {
        const selectedImage = File[0];
        // console.log(selectedImage);
        if (
          selectedImage &&
          selectedImage.type &&
          !selectedImage.type.startsWith("image")
        ) {
          this.attachImgError = "مسموح بالصور فقط";
        } else {
          this.attachImgError = "";
        }
        this.createBase64ImageForAttachments(selectedImage);
      }
    },
    createBase64ImageForAttachments(fileObject) {
      const reader = new FileReader();
      // const _this = this;
      reader.onload = (e) => {
        this.teacherRegistration.id_photo = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },

    addEditSubjectFees(gradeId) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let subjectFeesObj = {
        id: "",
        subject: "",
        hourFees: "",
        languages: [],
      };

      const difference = this.array_diff(
        this.teacherRegistration.subjects[gradeId],
        this.lastSubjectIds[gradeId]
      );
      let mode = "+";
      if (
        this.lastSubjectIds[gradeId].length >
        this.teacherRegistration.subjects[gradeId].length
      )
        mode = "-";
      console.log(mode);
      if (mode == "+") {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        difference.forEach((subjectId) => {
          subjectFeesObj.subject = this.panels[gradeId].find(
            (item) => item.id == subjectId
          ).name;
          subjectFeesObj.id = subjectId;
          this.teacherRegistration.subjectsFees[gradeId].push(subjectFeesObj);
          subjectFeesObj = {
            subject: "",
            hourFees: "",
            languages: [],
          };
        });
      } else {
        // console.log("difference ", difference[0]);
        let removeIndex = -1;
        this.lastSubjectIds[gradeId].forEach((item, index) => {
          // console.log("old indices");
          // console.log(index);
          if (item == difference[0]) {
            removeIndex = index;
          }
        });
        // console.log("----------------");

        if (removeIndex > -1)
          this.teacherRegistration.subjectsFees[gradeId].splice(removeIndex, 1);
      }
      this.lastSubjectIds[gradeId] = this.teacherRegistration.subjects[gradeId];
    },

    openTab(num) {
      this.panel = [];
      this.panel.push(num);
    },
    submit() {
      this.$refs.observer.validate();
      if (
        this.valid == false ||
        this.bankAttachImgError != "" ||
        this.attachImgError != ""
      ) {
        this.panel = [0, 1, 2, 3, 4, 5, 6, 7];
        this.openPanels = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        setTimeout(() => {
          this.validate();
        }, 1000);
        this.$refs.snack.sendErrorAlert(
          this.$i18n.t("You must enter required field with mark *")
        );
      } else {
        this.loading = true;
        this.$http
          .post(this.getApiUrl + "/teacher/register", this.teacherRegistration)
          .then((response) => {
            this.loading = false;
            if (response.data.status.error == false) {
              localStorage.email = response.data.data.user.email;
              localStorage.registered = true;
              if (this.isLoggedIn) {
                localStorage.type = "USR1500";
                window.location = "/";
              } else {
                this.$router.push({ path: "/activationCode" });
              }
            } else {
              if (
                Object.keys(response.data.status.validation_errors).length > 0
              ) {
                this.validationErrors = response.data.status.validation_errors;
              } else {
                this.$refs.snack.sendErrorAlert(response.data.status.message);
              }
            }
          });
      }
    },

    validateImage(file) {
      // console.log(file);
    },
    getUserData() {
      this.$http
        .get(this.getApiUrl + "/getUserData?type=teacher", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          this.teacherRegistration.first_name = response.data.data.first_name;
          this.teacherRegistration.family_name = response.data.data.family_name;
          this.teacherRegistration.email = response.data.data.email;
          this.teacherRegistration.country_code_id =
            response.data.data.country_code_id;
          this.teacherRegistration.mobile = response.data.data.mobile;
          this.teacherRegistration.title = response.data.data.gender;
        });
    },
    getCountryCodes() {
      this.$http.get(this.getApiUrl + "/getCodes").then((response) => {
        this.dataObject.Codes = response.data.data;
      });
    },
  },
  mounted() {
    this.getCountryCodes();
    extend("required", {
      ...required,
      message: this.$i18n.t("required"),
    });
    this.getDataForTeacherRegistration();
    this.submitOnClick();

    if (this.teacherOrStudent) {
      this.$router.push({ path: "/404" });
    } else if (this.isLoggedIn) {
      this.getUserData();
      this.teacherRegistration.from_market = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

.signUp {
  min-height: 50rem !important;
  background-image: url("../../assets/images/background-overlay.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed !important;
  position: relative;
  padding-top: $padding-top;

  .v-expansion-panels {
    .v-expansion-panel {
      margin-bottom: 1rem !important;
    }
  }

  .v-expansion-panel-content {
    background-color: $main-color;
  }

  .inner-expansion {
    label {
      color: $main-color !important;
    }
  }
  .signup-title {
    z-index: 999;
    // text-align: center;
  }
  .accordion-nav {
    margin-top: 5rem;
    // font-size: 14px;
    font-weight: 500;
    color: $second-color !important;
    li {
      cursor: pointer;
      margin-bottom: 0.5rem;
      font-size: 1.5rem;
    }
    li.active {
      font-weight: bold;
    }
  }
  .v-expansion-panel-header {
    color: #ffffff !important;

    .v-icon {
      color: #ffffff !important;
    }
  }

  .primary-btn {
    width: 100%;
    margin-left: 0 !important;
  }
}

label {
  color: #ffffff !important;
  padding-bottom: 10px !important;
  display: block;
}

.backend-error {
  margin-top: -20px;
  font-size: 12px !important;
  font-weight: bold;
}

.image-error {
  margin-top: 0 !important;
}
.no-caps {
  text-transform: none !important;
}

.profile-image {
  .v-image {
    margin: 0 auto !important;
    border-radius: 50% !important;
  }
  position: relative;
  .close-btn {
    border: 1px solid $main-color;
    position: absolute;
    right: 43%;
    bottom: 11px;
    background-color: #fff !important;
    z-index: 11111;
  }

  .edit-btn {
    right: 43%;
    top: 11px;
    position: absolute;
    border: 1px solid #13a8b1;
    background-color: #ffffff !important;
    display: inline-block;
    z-index: 11111;
    /* margin: 0 2rem !important */
  }
  .v-btn--icon.v-size--default {
    height: 20px !important;
    width: 20px !important;
  }
}

.password .v-icon {
  color: gray !important;
}
</style>
